/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiOrder, ApiOrderSnapshot } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of RequisitionOrdersController.
 */
export class RequisitionOrdersRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /requisitions/{requisitionId}/orders
     */
    public place(requisitionId: string, order: ApiOrder): Promise<Result<ApiOrderSnapshot>> {
        return this.http.post<Result<ApiOrderSnapshot>, ApiOrder>(`/requisitions/${requisitionId}/orders`, order);
    }

    /**
     * Calls GET /requisitions/{requisitionId}/orders:query
     */
    public getListGet(requisitionId: string, pageNo: number, pageSize: number): Promise<Result<ListInfo<ApiOrderSnapshot>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);

        return this.http.get<Result<ListInfo<ApiOrderSnapshot>>>(`/requisitions/${requisitionId}/orders:query`, query);
    }

    /**
     * Calls POST /requisitions/{requisitionId}/orders:query
     */
    public getListPost(requisitionId: string, listRequest: ListRequest): Promise<Result<ListInfo<ApiOrderSnapshot>>> {
        return this.http.post<Result<ListInfo<ApiOrderSnapshot>>, ListRequest>(`/requisitions/${requisitionId}/orders:query`, listRequest);
    }
}
